<template>

    <DragWrapper :top="500" :left="100">

        <!-- for some reason this transition doesn't work if outside DragWrapper -->
        <v-scroll-x-transition> 

            <v-card v-show="show" flat :width="width" class="mx-auto">

                    <v-system-bar drag-handle color="primary" dark :window="true">
                        <v-icon color="secondary">mdi-filter</v-icon>
                        <span>Filters</span>
                    </v-system-bar>
                    
                    <v-card-text>

                         <v-scroll-y-transition group>

                            <v-row class="py-1" transition="scroll-y-transition" justify="space-between" v-for="filter in filters" :key="filter.id">

                                <v-select
                                    hide-details
                                    style="max-width : 150px;"
                                    dense
                                    v-model="filter.property"
                                    :items="properties"
                                    label="property"
                                    outlined
                                    @change="applyFilters"
                                ></v-select>

                                <v-select 
                                    hide-details
                                    style="max-width : 100px;"
                                    dense
                                    item-text="name"
                                    return-object
                                    v-model="filter.operation"
                                    :items="operations"
                                    label="operation"
                                    outlined
                                    @change="applyFilters"
                                ></v-select>

                                <v-text-field color="secondary" @input="applyFilters" dense hide-details style="max-width : 80px;" v-model="filter.value"></v-text-field>
                                <v-icon class="mr-2" @click="removeFilter(filter)" color="error">mdi-close-circle</v-icon>

                            </v-row>


                        <v-row :key="-1" justify="space-between">

                            <span v-show="!filtersValid" class="error--text">Filters not valid</span>

                            <v-spacer></v-spacer>

                            <span>
                                <v-btn class="mr-2" outlined small>
                                    <v-icon color="secondary" @click="addFilter">mdi-filter-plus</v-icon>
                                </v-btn>
                            </span>
                            <span>
                                <v-btn class="mr-2" outlined small>
                                    <v-icon color="error" @click="clearFilters">mdi-filter-off</v-icon>
                                </v-btn>
                            </span>
                            
                        </v-row>

                        </v-scroll-y-transition>

                    </v-card-text>
                    
            </v-card>

        </v-scroll-x-transition>

    </DragWrapper>

</template>

<script>
import DragWrapper from './common/DragWrapper.vue'
import MainMap from '../classes/MainMap';

export default {
    
    components: {
        DragWrapper,
    },

    props: {
        width: {
            type: Number,
            default: 400,
        },

        map: {
            type: MainMap,
            require: true,
        },
        show : {
            type: Boolean,
            default : false
        }
       
    },

    data: () => ({
       filters : [],
       filterId : 0,
       operations : [
            {
                'name' : '=',
                'value' : '=',
                'formula' : (x, value) => {return x == value;},
            },
            {
                'name' : '>',
                'value' : '>',
                'formula' : (x, value) => {return x > value;},
            },
            {
                'name' : '<',
                'value' : '<',
                'formula' : (x, value) => {return x < value;},
            },
            {
                'name' : '≠',
                'value' : '!=',
                'formula' : (x, value) => {return x != value;},
            },
       ],
    }),

    methods: {
        addFilter() {

            this.filters.push({
                id : this.filterId,
                property : 'VV_mean',
                operation : this.operations[2],
                value : 0.05
            })

            this.filterId += 1;

            this.applyFilters();
        },

        removeFilter(filter) {
            this.filters = this.filters.filter(x => x.id != filter.id);
            this.applyFilters();
        },

        applyFilters() {
            
            if(!this.filtersValid)
                return;

            let features = this.map.getWetlandFeatures();

            this.filters.forEach(filter => {
                features = features.filter(f => {

                    return filter.operation.formula(
                        f.values_['stats'][filter.property],
                        JSON.parse(filter.value) // JSON.parse turns value to number and 'null' to null value
                        );
                })
            });

            this.map.filterWetlandFeatureStyles(features);


        },

        clearFilters() {
            this.filters = [];
            this.applyFilters();
        },

    },

    computed: {
        filtersValid() {

            if(this.filters.length <= 0)
                return true;

            return this.filters.every( x => {
                if(x.value == 'null') // allow searching for null
                    return true;

                return !isNaN(x.value); // this checks if its a number
            })
        },

        properties() {
            const features = this.map.getWetlandFeatures();

            let props = [];

            if(features && features.length > 0)
                props = Object.keys(features[0].getProperties()['stats']);

            return props;
        }
    }

};
</script>
